var _g, _g2, _g3, _g4, _g5, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCheckmarkWithBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 239190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_438_4862",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 67,
    height: 67
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "023de3ec0d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 -0.000976562H66.5V65.999H0.5V-0.000976562Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_438_4862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M66.5 32.999C66.5 51.2246 51.7256 65.999 33.5 65.999C15.2744 65.999 0.5 51.2246 0.5 32.999C0.5 14.7735 15.2744 -0.000976562 33.5 -0.000976562C51.7256 -0.000976562 66.5 14.7735 66.5 32.999Z",
    fill: "#0C85D0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_438_4862",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 17,
    width: 43,
    height: 49
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "3ecc58565b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.3438 17.8203H66.5013V65.9998H24.3438V17.8203Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_438_4862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_438_4862",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 67,
    height: 67
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "e6f1f90927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.5 32.999C66.5 51.2246 51.7256 65.999 33.5 65.999C15.2744 65.999 0.5 51.2246 0.5 32.999C0.5 14.7735 15.2744 -0.000976562 33.5 -0.000976562C51.7256 -0.000976562 66.5 14.7735 66.5 32.999Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_438_4862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M81.1852 44.5064L54.5461 17.8662L24.3613 48.2155L48.528 72.3813L81.1852 44.5064Z",
    fill: "#0772B4"
  })))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M54.1588 18.3248C53.2928 17.4702 52.1428 16.999 50.9192 16.999C49.6956 16.999 48.5447 17.4702 47.6796 18.3248L27.6903 38.0708L19.3183 29.8007C18.4532 28.9461 17.3022 28.4759 16.0786 28.4759C14.8551 28.4759 13.7051 28.9461 12.84 29.8007C11.0533 31.5647 11.0533 34.4362 12.84 36.2002L24.4086 47.6279C24.421 47.6411 24.4344 47.6553 24.4506 47.6714C24.6705 47.8876 24.9123 48.084 25.1695 48.2511C25.9189 48.7403 26.7917 48.999 27.6941 48.999C28.9177 48.999 30.0676 48.5278 30.9318 47.6742C30.9748 47.6326 53.2115 25.6591 54.1588 24.7242C55.0239 23.8697 55.5 22.7337 55.5 21.524C55.5 20.3154 55.0239 19.1794 54.1588 18.3248Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWithBackground);
export default __webpack_public_path__ + "static/media/checkmark-with-background.04d8872726470842adb2045ced962b95.svg";
export { ForwardRef as ReactComponent };